import { render, staticRenderFns } from "./tabIndex.vue?vue&type=template&id=fb674f2a&scoped=true&"
import script from "./tabIndex.vue?vue&type=script&lang=js&"
export * from "./tabIndex.vue?vue&type=script&lang=js&"
import style0 from "./tabIndex.vue?vue&type=style&index=0&id=fb674f2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb674f2a",
  null
  
)

export default component.exports